import me from '@/store/modules/integrations/projects/me';
import projects from '@/store/modules/integrations/projects/projects';

export default {
  me,
  projects,
};
